'use client';

import { useMemo, useState } from 'react';
import { useTranslations } from 'next-intl';
import {
  Segmented,
  SegmentedContainer,
  SegmentedItem,
} from '@crabs-ai/ds-react';
import AnimationItem from './AnimationItem';
import { getPresetsByCategory } from './animation-presets';
import type { AnimationCategory } from '../../../../items/animation/animation-item-type';

const ANIMATION_CATEGORIES: AnimationCategory[] = ['in', 'out', 'combo'];

export default function AnimationContent() {
  const t = useTranslations();
  const [selectedCategory, setSelectedCategory] =
    useState<AnimationCategory>('in');

  // 카테고리별 프리셋 필터링
  const filteredPresets = useMemo(() => {
    return getPresetsByCategory(selectedCategory);
  }, [selectedCategory]);

  return (
    <div className="@container flex h-full w-full flex-col px-md py-sm">
      {/* 피그마 시안과 동일한 segmented control 구조 */}
      <div className="py-2xs">
        <Segmented
          value={selectedCategory}
          onValueChange={(value) =>
            setSelectedCategory(value as AnimationCategory)
          }
          size="md"
        >
          <SegmentedContainer>
            {ANIMATION_CATEGORIES.map((category) => (
              <SegmentedItem
                key={category}
                value={category}
              >
                {t(`Editor.animation.category.${category}`)}
              </SegmentedItem>
            ))}
          </SegmentedContainer>
        </Segmented>
      </div>

      {/* 반응형 그리드 — 패널 폭(컨테이너 쿼리)에 따라 1~4열. 한 칸이 대략 170px 아래로
          내려가지 않는 지점에서만 열을 늘린다(16:9 프리뷰라 더 잘면 알아보기 힘들다). */}
      <div className="grid grid-cols-1 gap-2xs overflow-y-auto py-2xs layout-padding-bottom @[260px]:grid-cols-2 @[440px]:grid-cols-3 @[620px]:grid-cols-4">
        {filteredPresets.map((preset) => (
          <AnimationItem
            key={preset.type}
            type={preset.type}
            name={t(`Editor.animation.type.${preset.type}`)}
          />
        ))}
      </div>
    </div>
  );
}
